module.exports = __webpack_public_path__ + "img/crm03.8e5170c2.jpg";